import {IReservationFlowTransitions} from "../types/IReservationFlowEngine";
import {ReservationFlowState} from "../types/ReservationFlowState";
import {isReservationRequestPending} from "./get_reservation_code_step_view";
import {ReservationFlowAction, reservationFlowReducer} from "./reservation_flow_reducer";

interface ICreateReservationFlowTransitionsParams {
    stateRef: {readonly current: ReservationFlowState};
    setState: (state: ReservationFlowState) => void;
    // a countdown starts from the moment of the change
    refreshClock: () => void;
    setIsNewCodeSent: (isNewCodeSent: boolean) => void;
}

export const createReservationFlowTransitions = (params: ICreateReservationFlowTransitionsParams): IReservationFlowTransitions => {
    const {stateRef, setState, refreshClock, setIsNewCodeSent} = params;

    const apply = (action: ReservationFlowAction): ReservationFlowState => {
        const next = reservationFlowReducer(stateRef.current, action);

        if (next !== stateRef.current) {
            setState(next);
            refreshClock();
        }

        return next;
    };

    const applyChange = (action: ReservationFlowAction): ReservationFlowState | null => {
        const previous = stateRef.current;
        const next = apply(action);

        return next === previous ? null : next;
    };

    const applyCallStart = (action: ReservationFlowAction): ReservationFlowState | null => {
        const next = applyChange(action);

        if (next !== null && isReservationRequestPending(next)) {
            setIsNewCodeSent(false);
        }

        return next;
    };

    return {apply, applyChange, applyCallStart};
};
import {IReservationFlowTransitions} from "../types/IReservationFlowEngine";
import {ReservationFlowState} from "../types/ReservationFlowState";
import {isReservationRequestPending} from "./get_reservation_code_step_view";
import {ReservationFlowAction, reservationFlowReducer} from "./reservation_flow_reducer";

interface ICreateReservationFlowTransitionsParams {
    stateRef: {readonly current: ReservationFlowState};
    setState: (state: ReservationFlowState) => void;
    // a countdown starts from the moment of the change
    refreshClock: () => void;
    setIsNewCodeSent: (isNewCodeSent: boolean) => void;
}

export const createReservationFlowTransitions = (params: ICreateReservationFlowTransitionsParams): IReservationFlowTransitions => {
    const {stateRef, setState, refreshClock, setIsNewCodeSent} = params;

    const apply = (action: ReservationFlowAction): ReservationFlowState => {
        const next = reservationFlowReducer(stateRef.current, action);

        if (next !== stateRef.current) {
            setState(next);
            refreshClock();
        }

        return next;
    };

    const applyChange = (action: ReservationFlowAction): ReservationFlowState | null => {
        const previous = stateRef.current;
        const next = apply(action);

        return next === previous ? null : next;
    };

    const applyCallStart = (action: ReservationFlowAction): ReservationFlowState | null => {
        const next = applyChange(action);

        if (next !== null && isReservationRequestPending(next)) {
            setIsNewCodeSent(false);
        }

        return next;
    };

    return {apply, applyChange, applyCallStart};
};
